import { GLOBAL_DESTINATIONS, GLOBAL_PROVIDER_SETGINGS } from '../actions/actionTypes'

const global = (state = {}, action) => {
    switch (action.type) {
        case GLOBAL_DESTINATIONS:
            return {
                ...state,
                destinations: action.data
            }
        case GLOBAL_PROVIDER_SETGINGS:
            return {
                ...state,
                providers: action.data
            }
        default:
            return state;
    }
}

export default global


// WEBPACK FOOTER //
// ./src/reducers/globalReducer.js